module.exports = __webpack_public_path__ + "static/media/read.201fc726.png";